import axiosRetry from 'axios-retry'
import store from '@/store'
import { createClient } from './createClient'

export default createClient({
    baseURL: process.env.VUE_APP_GATEWAY_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-PICA-PLATFORM': 'dashboard'
    },
    getAuthHeader: () => {
        const token = store.state.login.token
        return token ? `${token.type} ${token.token}` : null
    },
    refreshAuth: async () => {
        const state = store.state.login
        if (!state.authMethod || !state.refreshToken) {
            throw new Error('No refresh token available')
        }
        const AuthProviderFactory = require('@/domain/login/providers/AuthProviderFactory').default
        const provider = AuthProviderFactory.getProvider(state.authMethod)
        if (!provider.supportsRefresh()) {
            throw new Error('Provider does not support refresh')
        }
        await store.dispatch('login/refreshAuthToken')
    },
    retry: {
        retries: 4,
        retryDelay: (retryNumber) => Math.pow(2, retryNumber) * 1000,
        retryCondition: axiosRetry.isNetworkOrIdempotentRequestError
    }
})
